import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { BigNumber } from 'bignumber.js'
import { Text } from 'rebass'

// components
import Loading from '../../components/Loader/Loading'
import { BodyHead, BodyTitle } from '../../components/bakery/styleds'
import NoWeapon from './components/NoWeapon'
import Weapon from './components/Weapon'
import { ButtonLight } from '../../components/Button'

import { AuctionBake } from '../../constants/artwork'

// hooks
import { useActiveWeb3React } from '../../hooks'
// import useMyEggs from '../../hooks/weapon/useMyWeapons'
import useInterval from '../../hooks/useInterval'
import { useWalletModalToggle } from '../../state/application/hooks'
import useAllowanceAll from '../../hooks/nft/useAllowanceAll'
// import { useMarketLevel } from '../../state/market/hooks'
import { getWeapons, getWeaponsV2, getWeaponsV3 } from '../../service/weapon'
import { MARKETTYPE, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import useMyArtworks from '../../hooks/commonNft/useMyArtworks'

const UpToButtonLight = styled(ButtonLight)`
  margin-top: 160px;
  padding: 0px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin-top: 80px;
  `}
`
const EggsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 1204px;
  margin: auto;
  box-sizing: border-box;
  justify-content: flex-start;

  ${({ theme }) => theme.mediaWidth.upToBigerLarge`
    width: 904px;
  `}

  ${({ theme }) => theme.mediaWidth.upToLarge`
    width: 628px;
  `}

  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 605px;
  `}

  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    padding: 0px 20px;
    justify-content: center;
  `}
`

export default function MyEggs () {
  const { account, chainId } = useActiveWeb3React()
  const toggleWalletModal = useWalletModalToggle()
  const [loadingFlag, setLoadingFlag] = useState(false)
  const [eggs, setEggs] = useState<any[]>([])
  // const level = useMarketLevel()
  // const getAllEggs = useMyEggs()

  const getAllArtworksV1 = useMyArtworks(MARKETTYPEV1.WEAPONNFTV1)
  const getAllArtworksV2 = useMyArtworks(MARKETTYPE.WEAPONNFT)
  const getAllArtworksV3 = useMyArtworks(MARKETTYPEV3.WEAPONNFTV3)

  const fetchAllEggs = async (first?: boolean) => {
    if (first) {
      setLoadingFlag(true)
    }
    const listV1 = await getAllArtworksV1(true)
    const listV2 = await getAllArtworksV2(true)
    const listV3 = await getAllArtworksV3()

    if (listV1.length || listV2.length || listV3.length) {
      fetchAsksSort({
        'v1': listV1,
        'v2': listV2,
        'v3': listV3
      }, first)
    }
    if (!listV1.length && !listV2.length && !listV3.length) {
      setLoadingFlag(false)
      setEggs([])
    }

    // const list = await getAllEggs()
    // if (list.length > 0) {
    //   fetchAsksSort(list, first)
    // } else {
    //   setEggs([])
    //   setLoadingFlag(false)
    // }
  }

  const getDataV1 = (params: any) => {
    return new Promise((resolve, reject) => {
      getWeapons(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.nftLevel = d.level
          d.level = 'v1'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }
  const getDataV2 = (params: any) => {
    return new Promise((resolve, reject) => {
      getWeaponsV2(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.nftLevel = d.level
          d.level = 'v2'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }
  const getDataV3 = (params: any) => {
    return new Promise((resolve, reject) => {
      getWeaponsV3(chainId as number, params, (err: any, data: any) => {
        if (err) {
          reject()
          return
        }
        if (data.code !== 0) {
          reject()
          return
        }
        const dataAry = data.data.list || []
        dataAry.forEach((d: any) => {
          d.nftLevel = d.level
          d.level = 'v3'
        })
        resolve(dataAry)
      })
    })
    .catch(() => [])
    .finally(() => {
      setLoadingFlag(false)
    })
  }

  const fetchAsksSort = async (noInfoArts: any, first?: boolean) => {
    if (first) {
      setLoadingFlag(true)
    }
    // let ids = ''
    // noInfoArts.forEach((d, index) => {
    //   ids = ids + d.tokenId
    //   if (index < noInfoArts.length - 1) {
    //     ids = ids + ','
    //   }
    // })
    let params = {}
    const idsV1 = noInfoArts.v1.join(',')
    const idsV2 = noInfoArts.v2.join(',')
    const idsV3 = noInfoArts.v3.join(',')
    const paramsV1 = {
      ...params,
      ids: idsV1
    }
    const paramsV2 = {
      ...params,
      ids: idsV2
    }
    const paramsV3 = {
      ...params,
      ids: idsV3
    }
    const handleDataArtworks = (arr: any) => {
      const artworks = arr.map((d: any) => {
        return {
          exchangeAddress: d.exchangeAddress,
          level: d.level,
          tokenId: d.id.toString(),
          nftLevel: d.nftLevel,
            ...(d.price && Number(d.price) ? {price: d.price.toString()} : {}),
            petToGet: (new BigNumber(d.petToGet.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
            bakeToGet: (new BigNumber(d.bakeToGet.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
            stakingPower: (new BigNumber(d.stakingPower.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
            ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {}),
            nftType: 12,
            maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
        }
      })
      return artworks
    }
    let listV1
    let listV2
    let listV3

    if (idsV1) {
      listV1 = await getDataV1(paramsV1)
    } else {
      listV1 = []
    }
    if (idsV2) {
      listV2 = await getDataV2(paramsV2)
    } else {
      listV2 = []
    }
    if (idsV3) {
      listV3 = await getDataV3(paramsV3)
    } else {
      listV3 = []
    }

    const artworksV1 = handleDataArtworks(listV1)
    const artworksV2 = handleDataArtworks(listV2)
    const artworksV3 = handleDataArtworks(listV3)
    setLoadingFlag(false)
    setEggs([...artworksV3, ...artworksV2, ...artworksV1])

    // if (level === 'v1') {
    //   getWeapons(chainId as number, params, (err: any, data: any) => {
    //     setLoadingFlag(false)
    //     if (err) return
    //     if (data.code !== 0) return
    //     const dataAry = data.data.list || []
    //     const eggs = dataAry.map((d: any) => {
    //       return {
    //         tokenId: d.id.toString(),
    //         level: d.level.toString(),
    //         ...(d.price && Number(d.price) ? {price: d.price.toString()} : {}),
    //         petToGet: (new BigNumber(d.petToGet.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
    //         bakeToGet: (new BigNumber(d.bakeToGet.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
    //         stakingPower: (new BigNumber(d.stakingPower.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
    //         ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {}),
    //         nftType: 12,
    //         maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
    //       }
    //     })
    //     setEggs(eggs)
    //   })
    // } else {
    //   getWeaponsV2(chainId as number, params, (err: any, data: any) => {
    //     setLoadingFlag(false)
    //     if (err) return
    //     if (data.code !== 0) return
    //     const dataAry = data.data.list || []
    //     const eggs = dataAry.map((d: any) => {
    //       return {
    //         tokenId: d.id.toString(),
    //         level: d.level.toString(),
    //         ...(d.price && Number(d.price) ? {price: d.price.toString()} : {}),
    //         petToGet: (new BigNumber(d.petToGet.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
    //         bakeToGet: (new BigNumber(d.bakeToGet.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
    //         stakingPower: (new BigNumber(d.stakingPower.toString()).integerValue(BigNumber.ROUND_FLOOR).toNumber()),
    //         ...((d.auctionPrice && Number(d.auctionPrice)) && (d.price && Number(d.price) && +d.price === AuctionBake) ? {auctionPrice: d.auctionPrice.toString()} : {}),
    //         nftType: 12,
    //         maxBidPrice: (d.maxBidPrice && !Number(d.maxBidPrice)) && (d.auctionPrice && Number(d.auctionPrice)) ? d.auctionPrice.toString() : d.maxBidPrice
    //       }
    //     })
    //     setEggs(eggs)
    //   })
    // }
  }

  useEffect(() => {
    if (account) {
      fetchAllEggs(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account])

  useInterval(fetchAllEggs, account ? 10000 : null)

  const allowanceSellAll = useAllowanceAll(
    {
      type: MARKETTYPEV3.WEAPONNFTV3,
      marketFlag: 'market'
    }
  )

  return (
    <>
      <Loading open={loadingFlag} />
      {
        !account ? (
          <UpToButtonLight width={'180px'} height={40} onClick={toggleWalletModal}>
            Connect Wallet
          </UpToButtonLight>
        ) : <>
          <BodyHead>
            <BodyTitle fontSize={32} fontWeight={700}>My Weapons</BodyTitle>
            <Text fontSize={16}>
            Wish you could get the NFTs you want
            </Text>
          </BodyHead>
          {
            loadingFlag
              ? null
              : !account || eggs.length === 0 ? (
                <NoWeapon ownBtn={true} />
              ) : (
                <EggsList>
                  {
                    eggs.map((d) => {
                      return (
                        <Weapon allowanceSellAll={allowanceSellAll} key={d.tokenId} egg={d} isMyEgg={true} />
                      )
                    })
                  }
                </EggsList>
              )
          }
        </>
      }
    </>
  )
}